import { ctor } from 'from2';
import { async } from 'regenerator-runtime';
import {
  req,
  imgServer,
  googlePlaceDataAPI,
  getWebsiteData,
} from '../js/config';
import { currencyFormatter } from '../js/base';
import { preloader, withPreloader } from '../js/preloader';
//import { ToHTML, ToHTMLWithFormatting } from "../js/base";
//import { async } from "regenerator-runtime";
let PageData = {};
const Initialize = async () => {
  // Initialize preloader manager with timeout protection
  preloader.init();
  
  try {
    // Wrap API calls with timeout protection
    await withPreloader(async () => {
      await getPageData();
      console.log('getPageData', PageData);
      await generatePageHTML();
    }, { timeout: 8000 }); // 8 second timeout for data loading

    await loadJavascriptNow();
    
    // Hide preloader on success
    preloader.hide();
  } catch (err) {
    console.error('Error during initialization:', err);
    // Preloader will be automatically hidden by the withPreloader function
  }
};

const getPageData = async () => {
  // const respData = await req(`cars?populate=*`).catch(function (response) {
  //});
  let WebData = await getWebsiteData();
  PageData = WebData.filter((x) => x.attributes.Status === 'Available');
};

const generatePageHTML = async () => {
  document.querySelector('#yearsInBusiness').innerHTML =
    new Date().getFullYear() - 2006;
  document.querySelector('#carsSold').innerHTML = '1200+';
  document.querySelector('#copyrightYearsFooter').innerHTML =
    '&copy;' +
    new Date().getFullYear() +
    ' <span> Hansen Truck & Car Sales</span';
  document.querySelector('#copyrightYearsMobileMenu').innerHTML =
    '&copy;' +
    new Date().getFullYear() +
    ' <span> Hansen Truck & Car Sales</span';

  await newlyAddedBlock();

  await browseByTypeBlock();

  await inventoryBlock();

  // Handle Google Places data with comprehensive error handling
  try {
    const testimonials = await googlePlaceData();
    console.log('Google Places data received:', testimonials);
    
    // Always try to build testimonials (has built-in fallback)
    await buildTestimonials(testimonials);
    
    // Handle business hours with fallback
    await updateCurrentDayHours(testimonials?.opening_hours);
    
    // Handle phone number with fallback  
    await phoneNumber(testimonials?.formatted_phone_number);
    
    // Handle address with fallback
    await address(testimonials?.formatted_address);
    
  } catch (error) {
    console.error('Error processing Google Places data:', error);
    
    // Ensure fallback data is shown even if Google API completely fails
    await buildTestimonials(null);
    await updateCurrentDayHours(null);
    await phoneNumber(null);
    await address(null);
  }

  await fillBodyTypes();
};

const fillBodyTypes = async (h) => {
  document.querySelector('#typeSedan').innerHTML =
    'Sedan (' +
    PageData.filter((s) => s.attributes.Category == 'Sedan').length +
    ')';
  document.querySelector('#typeWagon').innerHTML =
    'Wagon/Hatchback (' +
    (PageData.filter((s) => s.attributes.Category == 'Wagon').length +
      PageData.filter((s) => s.attributes.Category == 'Hatchback').length) +
    ')';
  document.querySelector('#typeSuv').innerHTML =
    'SUV (' +
    PageData.filter((s) => s.attributes.Category == 'SUV').length +
    ')';
  document.querySelector('#typeCrossover').innerHTML =
    'Crossover (' +
    PageData.filter((s) => s.attributes.Category == 'Crossover').length +
    ')';
  document.querySelector('#typeCoupe').innerHTML =
    'Coupe (' +
    PageData.filter((s) => s.attributes.Category == 'Coupe').length +
    ')';
  document.querySelector('#typeConvertible').innerHTML =
    'Convertible (' +
    PageData.filter((s) => s.attributes.Category == 'Convertible').length +
    ')';
  document.querySelector('#typeSportscar').innerHTML =
    'Sports Car (' +
    PageData.filter((s) => s.attributes.Category == 'Sports Car').length +
    ')';
  document.querySelector('#typePickup').innerHTML =
    'Pickup Truck (' +
    PageData.filter((s) => s.attributes.Category == 'Pickup Truck').length +
    ')';
};

const updateCurrentDayHours = async (h) => {
  try {
    if (!h || !h.weekday_text || !Array.isArray(h.weekday_text) || h.weekday_text.length === 0) {
      console.warn('Invalid opening hours data, using default hours');
      showDefaultBusinessHours();
      return;
    }

    let currentDay = new Date().getDay();
    currentDay == 0 ? (currentDay = 7) : currentDay;

    // Check if the current day index is valid
    if (currentDay > 0 && currentDay <= h.weekday_text.length) {
      const currentDayElement = document.querySelector('#currentDayHours');
      if (currentDayElement) {
        currentDayElement.innerHTML = h.weekday_text[currentDay - 1];
      }
    }

    // Generate working hours list
    let tpa = '';
    for (let i = 0; i < h.weekday_text.length; i++) {
      if (h.weekday_text[i]) {
        tpa += `<li>${h.weekday_text[i]}</li>`;
      }
    }
    
    const workingHoursElement = document.querySelector('#workingHours');
    if (workingHoursElement) {
      workingHoursElement.innerHTML = tpa || showDefaultBusinessHours();
    }
  } catch (error) {
    console.error('Error updating business hours:', error);
    showDefaultBusinessHours();
  }
};

// Helper function for default business hours
const showDefaultBusinessHours = () => {
  const defaultHours = [
    'Monday: 9:00 AM - 7:00 PM',
    'Tuesday: 9:00 AM - 7:00 PM', 
    'Wednesday: 9:00 AM - 7:00 PM',
    'Thursday: 9:00 AM - 7:00 PM',
    'Friday: 9:00 AM - 7:00 PM',
    'Saturday: 9:00 AM - 5:00 PM',
    'Sunday: 11:00 AM - 4:00 PM'
  ];
  
  const currentDayElement = document.querySelector('#currentDayHours');
  const workingHoursElement = document.querySelector('#workingHours');
  
  if (currentDayElement) {
    const currentDay = new Date().getDay();
    const adjustedDay = currentDay === 0 ? 6 : currentDay - 1; // Adjust Sunday to index 6
    currentDayElement.innerHTML = defaultHours[adjustedDay] || 'Call for hours';
  }
  
  if (workingHoursElement) {
    const hoursHtml = defaultHours.map(hour => `<li>${hour}</li>`).join('');
    workingHoursElement.innerHTML = hoursHtml;
  }
};

const phoneNumber = async (p) => {
  try {
    // Use default phone number if Google data is unavailable
    const defaultPhone = '(905) 463-0928';
    const phone = (p && typeof p === 'string') ? p : defaultPhone;
    
    const cleanPhone = phone.replace(/[\s\-\(\)]+/g, '');
    const phoneHTML = `<a href="tel:+${cleanPhone}">${phone}</a>`;
    
    const phoneElement = document.querySelector('#phoneNumber');
    const footerPhoneElement = document.querySelector('#footerPhoneNumber');
    
    if (phoneElement) {
      phoneElement.innerHTML = phoneHTML;
    }
    if (footerPhoneElement) {
      footerPhoneElement.innerHTML = phoneHTML;
    }
    
    console.log(`Phone number set to: ${phone}`);
  } catch (error) {
    console.error('Error setting phone number:', error);
    // Set fallback phone number
    const fallbackHTML = '<a href="tel:+19054630928">(905) 463-0928</a>';
    const phoneElement = document.querySelector('#phoneNumber');
    const footerPhoneElement = document.querySelector('#footerPhoneNumber');
    
    if (phoneElement) phoneElement.innerHTML = fallbackHTML;
    if (footerPhoneElement) footerPhoneElement.innerHTML = fallbackHTML;
  }
};
//<a href="geo:37.421999,-122.0862462" target="_blank">
//Visit Us: 1600 Amphitheatre Parkway, Mountain View, CA
//</a>

const address = async (a) => {
  try {
    // Use default address if Google data is unavailable
    const defaultAddress = '5 Hansen Rd S, Brampton, ON L6W 3H6, Canada';
    const address = (a && typeof a === 'string') ? a : defaultAddress;
    
    const addressHTML = `<a href="https://www.google.com/maps?q=${encodeURIComponent(address)}" target="_blank">${address}</a>`;
    
    const addressElement = document.querySelector('#address');
    const footerAddressElement = document.querySelector('#footerAddress');
    
    if (addressElement) {
      addressElement.innerHTML = addressHTML;
    }
    if (footerAddressElement) {
      footerAddressElement.innerHTML = addressHTML;
    }
    
    console.log(`Address set to: ${address}`);
  } catch (error) {
    console.error('Error setting address:', error);
    // Set fallback address
    const fallbackAddress = '5 Hansen Rd S, Brampton, ON L6W 3H6, Canada';
    const fallbackHTML = `<a href="https://www.google.com/maps?q=${encodeURIComponent(fallbackAddress)}" target="_blank">${fallbackAddress}</a>`;
    
    const addressElement = document.querySelector('#address');
    const footerAddressElement = document.querySelector('#footerAddress');
    
    if (addressElement) addressElement.innerHTML = fallbackHTML;
    if (footerAddressElement) footerAddressElement.innerHTML = fallbackHTML;
  }
};

const newlyAddedBlock = async () => {
  let tpl = '';

  PageData.sort((a, b) => parseFloat(b.id) - parseFloat(a.id)).forEach((d) => {
    tpl += `<div class="trending-col">
        <div class="single-trending-items">
        <a href="cardetail.html?id=${
          d.id
        }&location=brampton&used-car-for-sale=${
      d.attributes.Year + ' ' + d.attributes.Make + ' ' + d.attributes.Model
    }">
                <img src="${
                  imgServer +
                  d.attributes.Images.data[0].attributes.formats.small.url
                }"
                   
                    alt="">

                <span class="content">
                    <span>${
                      d.attributes.Year +
                      ' ' +
                      d.attributes.Make +
                      ' ' +
                      d.attributes.Model
                    } </span>
                    <span class="price">${currencyFormatter.format(
                      d.attributes.Price
                    )}</span>
                </span>
            </a>
        </div>
    </div>`;
  });

  document.querySelector('#pageIndexNewlyAdded').innerHTML = tpl;
};

const browseByTypeBlock = async () => {};

const generateInlineSlider = (ce, d) => {
  if (d.attributes.formats != null) {
    //console.log('🚀 ~ file: main.js:261 ~ generateInlineSlider ~ x:', d);
    let tpl = `<div class="swiper-slide">
                 <a href="cardetail.html?id=${
                   ce.id
                 }&location=brampton&used-car-for-sale=${
      ce.attributes.Year + ' ' + ce.attributes.Make + ' ' + ce.attributes.Model
    }">
                    <img src="${
                      imgServer + d.attributes.formats.small.url
                    }" alt="">
                 </a>
               </div>`;
    return tpl;
  }
};
const generateInlineSliders = (x) => {
  //console.log('🚀 ~ file: main.js:205 ~ generateInlineSliders ~ x:', x);
  let tpl = ``;

  //x.attributes.Images.data.forEach((d) => (tpl += generateInlineSlider(x, d)));

  if (x.attributes.Images.data.length > 0) {
    tpl += generateInlineSlider(x, x.attributes.Images.data[0]); // Directly access the first image
  }

  return tpl;
};

const inventoryBlock = async () => {
  let tpl = '';

  for (let index = 0; index < PageData.length; index += 2) {
    const ce = PageData[index];
    const ne = index + 1 <= PageData.length ? PageData[index + 1] : -1;

    tpl += `<div class="car-col">
                    <div class="single-car-item mt-50">
                        <div class="car-image">
                            <div class="swiper mySwiper">
                                <div class="swiper-wrapper">
                                ${generateInlineSliders(ce)};
                                </div>
                            </div>
                            <ul class="car-meta">                             
                                <li>
                                    <a href="cardetail.html?id=${
                                      ce.id
                                    }&location=brampton&used-car-for-sale=${
      ce.attributes.Year + ' ' + ce.attributes.Make + ' ' + ce.attributes.Model
    }"></a>
                                </li>
                            </ul>
                        </div>
                        <div class="car-content">
                            <span class="body-type"><a href="#">${
                              ce.attributes.Category
                            }</a></span>
                            <h4 class="car-title">   <a href="cardetail.html?id=${
                              ce.id
                            }&location=brampton&used-car-for-sale=${
      ce.attributes.Year + ' ' + ce.attributes.Make + ' ' + ce.attributes.Model
    }">${
      ce.attributes.Year + ' ' + ce.attributes.Make + ' ' + ce.attributes.Model
    }</a></h4>
                            <span class="price">
                                <span class="price-amount">${currencyFormatter.format(
                                  ce.attributes.Price
                                )}</span>
                            </span>
                        </div>
                    </div>               
    `;
    // console.log("🚀 ~ file: main.js ~ line 112 ~ inventoryBlock ~ ne", ne)
    if (ne !== undefined && ne != -1) {
      tpl += ` <div class="single-car-item mt-50">
            <div class="car-image">
                <div class="swiper mySwiper">
                    <div class="swiper-wrapper">
                        ${generateInlineSliders(ne)};
                    </div>
                </div>


           
                <ul class="car-meta">                             
                    <li>
                        
                           
                            <a href="cardetail.html?id=${
                              ne.id
                            }&location=brampton&used-car-for-sale=${
        ne.attributes.Year +
        ' ' +
        ne.attributes.Make +
        ' ' +
        ne.attributes.Model
      }">
                               
                            </a>
                       
                    </li>
                </ul>
            </div>
            <div class="car-content">
                <span class="body-type"><a href="#">${
                  ne.attributes.Category
                }</a></span>
                <h4 class="car-title"> <a href="cardetail.html?id=${
                  ne.id
                }&location=brampton&used-car-for-sale=${
        ne.attributes.Year +
        ' ' +
        ne.attributes.Make +
        ' ' +
        ne.attributes.Model
      }">${
        ne.attributes.Year +
        ' ' +
        ne.attributes.Make +
        ' ' +
        ne.attributes.Model
      }</a></h4>
                <span class="price">
                    <span class="price-amount">${currencyFormatter.format(
                      ne.attributes.Price
                    )}</span>
                </span>
            </div>
        </div>`;
    }

    tpl += `</div>`;
  }

  document.querySelector('#pageIndexInventory').innerHTML = tpl;
};

const loadJavascriptNow = async () => {
  const script = document.createElement('script');
  script.src = 'assets/js/main.js';

  // Append to the `head` element
  document.head.appendChild(script);

  var swiper = new Swiper('.mySwiper', {});

  $('.mySwiper').on('touchstart', function (event) {
    event.stopPropagation();
  });
};

const googlePlaceData = async () => {
  const data = await googlePlaceDataAPI();
  console.log('🚀 ~ file: main.js ~ line 162 ~ googlePlaceData ~ data', data);
  return data;
};

const buildTestimonialStarRating = (r) => {
  let tmp = '';

  for (let index = 0; index < r.rating; index++) {
    tmp += '<li> <i class="ion-ios-star"></i></li>';
  }

  return tmp;
};

const buildTestimonials = async (t) => {
  console.log('Google testimonials data:', t);
  let tmp = '';

  // Check if testimonials data and reviews exist
  if (!t || !t.reviews || !Array.isArray(t.reviews) || t.reviews.length === 0) {
    console.log('No Google reviews available, showing fallback testimonials');
    // Show fallback testimonials when Google data is unavailable
    tmp = `
      <div class="testimonial-col">
        <div class="single-testimonial">
          <div class="testimonial-content">
            <div class="title-rating d-flex align-items-center">
              <h3 class="testimonial-title">Customer Reviews</h3>
              <ul class="testimonial-rating d-flex">
                <li><i class="ion-ios-star"></i></li>
                <li><i class="ion-ios-star"></i></li>
                <li><i class="ion-ios-star"></i></li>
                <li><i class="ion-ios-star"></i></li>
                <li><i class="ion-ios-star"></i></li>
              </ul>
            </div>
            <p>"Great selection of quality used cars. The staff was very helpful and professional. Highly recommend Hansen for anyone looking for a reliable vehicle!"</p>
          </div>
          <div class="testimonial-author d-flex align-items-center">
            <div class="author-image">
              <img src="assets/images/author-1.jpg" alt="Customer Review">
            </div>
            <div class="author-content media-body">
              <h4 class="author-name">Happy Customer</h4>
              <div class="designation">Verified Purchase</div>
            </div>
          </div>
        </div>
      </div>
      <div class="testimonial-col">
        <div class="single-testimonial">
          <div class="testimonial-content">
            <div class="title-rating d-flex align-items-center">
              <h3 class="testimonial-title">Customer Reviews</h3>
              <ul class="testimonial-rating d-flex">
                <li><i class="ion-ios-star"></i></li>
                <li><i class="ion-ios-star"></i></li>
                <li><i class="ion-ios-star"></i></li>
                <li><i class="ion-ios-star"></i></li>
                <li><i class="ion-ios-star"></i></li>
              </ul>
            </div>
            <p>"Excellent customer service and fair pricing. Will definitely return for our next vehicle purchase."</p>
          </div>
          <div class="testimonial-author d-flex align-items-center">
            <div class="author-image">
              <img src="assets/images/author-2.jpg" alt="Customer Review">
            </div>
            <div class="author-content media-body">
              <h4 class="author-name">Satisfied Customer</h4>
              <div class="designation">Repeat Customer</div>
            </div>
          </div>
        </div>
      </div>`;
  } else {
    // Process Google reviews safely
    try {
      t.reviews.forEach((r) => {
        if (r && r.rating && r.text && r.author_name) {
          tmp += `<div class="testimonial-col">
                    <div class="single-testimonial">
                        <div class="testimonial-content">
                            <div class="title-rating d-flex align-items-center">
                                <h3 class="testimonial-title">Google Review</h3>
                                <ul class="testimonial-rating d-flex">
                                    ${buildTestimonialStarRating(r)}
                                </ul>
                            </div>
                            <p>${r.text}</p>
                        </div>
                        <div class="testimonial-author d-flex align-items-center">
                            <div class="author-image">
                                <img src="${r.profile_photo_url || 'assets/images/author-1.jpg'}" 
                                     alt="${r.author_name}" 
                                     onerror="this.src='assets/images/author-1.jpg'">
                            </div>
                            <div class="author-content media-body">
                                <h4 class="author-name">${r.author_name}</h4>
                                <div class="designation">
                                  ${r.relative_time_description || 'Recent'} on 
                                  <a href="${r.author_url || '#'}" target="_blank">Google Reviews</a>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>`;
        }
      });
    } catch (error) {
      console.error('Error processing Google reviews:', error);
      // Fall back to default testimonials if processing fails
      tmp = `<div class="testimonial-col">
        <div class="single-testimonial">
          <div class="testimonial-content">
            <div class="title-rating d-flex align-items-center">
              <h3 class="testimonial-title">Customer Testimonials</h3>
              <ul class="testimonial-rating d-flex">
                <li><i class="ion-ios-star"></i></li>
                <li><i class="ion-ios-star"></i></li>
                <li><i class="ion-ios-star"></i></li>
                <li><i class="ion-ios-star"></i></li>
                <li><i class="ion-ios-star"></i></li>
              </ul>
            </div>
            <p>"Excellent service and quality vehicles. Hansen Truck & Car Sales exceeded our expectations!"</p>
          </div>
        </div>
      </div>`;
    }
  }

  const testimonialContainer = document.querySelector('#testimonialData');
  if (testimonialContainer) {
    testimonialContainer.innerHTML = tmp;
  }
};

Initialize();
